import { groupMapTours, stopPoint, validMapPoint } from "./mapTours";

export function groupMobileTours(tours) {
  // Compare every displayed field, including care instructions and time warnings.
  const groups = new Map();
  for (const tour of tours) {
    const { tag, ...content } = tour;
    const signature = JSON.stringify(content);
    if (!groups.has(signature)) groups.set(signature, []);
    groups.get(signature).push(tour);
  }
  return [...groups.values()].flatMap(group => groupMapTours(group)).map((group, index) => ({ ...group, key: `mobile-${index}` }));
}

const addressKey = value => String(value || "").trim().replace(/\s+/g, " ").toLocaleLowerCase("de");
export const navigationPoint = stop => validMapPoint(stopPoint(stop)) ? stopPoint(stop).join(",")
  : (stop.address?.trim() && stop.address.trim() !== "-" ? stop.address.trim() : null);

export function navigationStops(tour) {
  const stops = [];
  for (const [index, stop] of (tour.stops || []).entries()) {
    const previous = stops[stops.length - 1];
    const address = addressKey(stop.address);
    const sameAddress = address && address !== "-" && address === addressKey(previous?.address);
    const sameCoordinates = validMapPoint(stopPoint(stop)) && validMapPoint(stopPoint(previous || {}))
      && stopPoint(stop).every((value, i) => Math.abs(value - stopPoint(previous)[i]) < 0.000001);
    if (previous && (sameAddress || sameCoordinates)) {
      previous.last = index + 1;
      if (!validMapPoint(stopPoint(previous)) && validMapPoint(stopPoint(stop))) previous.location = stop.location;
    } else stops.push({ ...stop, first: index + 1, last: index + 1 });
  }
  return stops;
}

export function googleMapsRoutes(tour, { mobileBrowser = false } = {}) {
  const stops = navigationStops(tour);
  const points = stops.map(navigationPoint);
  // App/desktop: nine waypoints. Optional browser fallback: three.
  // Origin is deliberately omitted so Maps starts at the current device location.
  if (points.length < 2 || points.some(point => !point)) return [];
  const links = [];
  const maxDestinations = mobileBrowser ? 4 : 10;
  for (let start = 0; start < points.length;) {
    let end = Math.min(start + maxDestinations - 1, points.length - 1);
    const makeUrl = () => {
      const params = new URLSearchParams({ api: "1", destination: points[end], travelmode: "driving", dir_action: "navigate" });
      if (end > start) params.set("waypoints", points.slice(start, end).join("|"));
      // Encode spaces as %20 rather than form-style '+' for app handoff.
      return `https://www.google.com/maps/dir/?${params.toString().replace(/\+/g, "%20")}`;
    };
    while (end > start && makeUrl().length > 2000) end--;
    links.push({ url: makeUrl(), first: stops[start].first, last: stops[end].last });
    start = end + 1;
  }
  return links;
}

export function stopNavigationUrl(stop) {
  const point = navigationPoint(stop);
  return point ? `https://www.google.com/maps/dir/?${new URLSearchParams({ api: "1", destination: point, travelmode: "driving", dir_action: "navigate" }).toString().replace(/\+/g, "%20")}` : null;
}
